<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">business</v-icon>
			<v-toolbar-title>Projekty</v-toolbar-title>
			<v-spacer/>
			<v-toolbar-title>Liczba realizowanych projektów: {{projects.length}}</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<v-subheader>
							<strong>{{getProjectListLabel}}</strong>
						</v-subheader>
						<v-btn flat icon class="mr-5" @click="handleListExpansion">
							<v-icon>{{getProjectListIcon}}</v-icon>
						</v-btn>
					</div>
				</v-flex>
				<v-flex xs6>
					<i v-if="!showProjectList">Lista ukryta</i>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs9>
					<v-expand-transition v-if="showProjectList">
						<v-list three-line>
							<template v-for="project in projects">
								<v-list-tile :key="project.id" avatar class="list-item">
									<v-list-tile-avatar>
										<v-icon>business</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="project.title"
											style="font-size: 14px"></v-list-tile-title>
										<v-list-tile-sub-title
											v-html="project.mainBidder.polishName"></v-list-tile-sub-title>
										<v-list-tile-action-text
											v-html="'Numer: ' + project.projectCode"></v-list-tile-action-text>
										<v-list-tile-action-text
											v-html="'Status: ' + getProjectStatus(project.projectStatus)"></v-list-tile-action-text>
									</v-list-tile-content>
									<v-list-tile-action>
										<egranty-icon-button
											icon="description"
											label="Podgląd"
											for="contest-summary-projects-view-list-preview"
											id="contest-summary-projects-view-list-preview"
											@click="viewProject(project.id)"/>
									</v-list-tile-action>
								</v-list-tile>
							</template>
						</v-list>
					</v-expand-transition>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {PublicContest} from "../../../../api/generated/PublicContest";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";

	export default {
		name: "ContestSummaryProjectsView",
		components: {EgrantyIconButton},
		data () {
			return {
				projects: [],
				showProjectList: false,
				dataLoaded: false
			};
		},

		created () {
			this.getContestSummaryProjectsData();
		},

		computed: {
			getProjectListLabel () {
				return this.showProjectList ? 'Ukryj listę' : 'Wyświetl listę';
			},

			getProjectListIcon () {
				return this.showProjectList ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
			}
		},

		methods: {
			getContestSummaryProjectsData () {
				PublicContest.getProjects(this, this.$route.params.id, successResponse => {
						this.projects = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować projektów", errorResponse);
					});
			},

			handleListExpansion () {
				this.showProjectList = !this.showProjectList;
			},

			getProjectStatus (status) {
				switch (status) {
					case "NEW":
						return "Nowy";
					case "APPROVED":
						return "Zaakceptowany";
					case "REQUESTED_CHANGES":
						return "Oczekuje na poprawki";
					case "POST_CORRECTION_MAIN":
						return "Oczekuje na akceptację";
					case "CORRECTED":
						return "Poprawiony";
					case "AGREEMENT_SIGNED":
						return "Umowa podpisana";
					case "WITHDRAWN":
						return "Anulowany";
					default:
						return "-";
				}
			},

			viewProject (projectId) {
				this.$router.openInNewTab("/view/project/" + projectId);
			},
		}
	};
</script>

<style scoped>
	.v-list__tile__title {
		line-height: 30px;
		word-wrap: break-word;
	}
</style>